import React from 'react';
import DOMPurify from "dompurify";
import { forwardRef } from 'react';


const PrintPaper = forwardRef(({ html, children }, ref) => {
    console.log('====================================');
    console.log(ref);
    console.log('====================================');
    const cleanedContract = DOMPurify.sanitize(html, {
        ALLOWED_ATTR: [
            "href",
            "title",
            "target",
            "style",
            "class",
            "colspan",
            "rowspan",
            "width",
            "height",
            "align",
            "src",
            "alt",
            "dir"
        ],
    }).replace(/font-family\s*:[^;"']*;?/gi, "");
    return (
        <div
            ref={ref}
            className="contract-wrapper">
            <div
                dangerouslySetInnerHTML={{ __html: cleanedContract }}
                style={{ margin: "30px" }}
            ></div>
            {children}
        </div>
    );
})
PrintPaper.displayName = "PrintPaper";

export default PrintPaper;